import { ISpecSheet } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../queries/useApplicationCache';

/**
 * Reads the Spec Sheet form for a given property from the React Query application cache.
 */
export function useSpecSheetCache(propertyGuid: string): ISpecSheet | undefined {
    return useApplicationCache(d =>
        d.information?.properties?.forms?.find(
            f => f.type === 'Spec Sheet' && f.propertyGuid === propertyGuid
        ) as ISpecSheet | undefined
    );
}
